import { useCallback } from 'react';

import { useNavigate } from 'react-router';

import { SwingFoundationsEditor } from '@screens';

import { LINKS } from '../utils/routes';

export const SwingFoundationsEditorScreen = () => {
    const navigate = useNavigate();
    const navigateToCurrentActivity = useCallback(() => {
        navigate(LINKS.getFullActivity());
    }, [navigate]);

    return <SwingFoundationsEditor onClose={navigateToCurrentActivity} />;
};
